import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
export const Faq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cómo recibo el Kit después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el acceso y el link de descarga de todos los PDFs. En menos de 5 minutos tenés todo disponible en tu dispositivo.'
  }, {
    q: '¿Sirve si recién empiezo a dar clases?',
    a: 'Sí. El Kit está diseñado para cualquier nivel de experiencia. Si recién empezás, el Módulo 1 te da el sistema de diagnóstico y planificación que necesitás desde la primera clase. Si ya tenés experiencia, los módulos 3, 4 y 6 te dan las herramientas para escalar y cobrar más.'
  }, {
    q: '¿Los 6 bonos están incluidos en las dos ofertas?',
    a: 'Sí. Los 6 bonos estratégicos están incluidos en ambas ofertas sin costo extra. La diferencia del Pack PRO son los 2 Tomos adicionales — Italiano Corporativo y De Profesor a Negocio Digital.'
  }, {
    q: '¿Sirve si ya preparo alumnos para ciudadanía o CILS?',
    a: 'Especialmente para vos. Los módulos 3 y 4 te dan los criterios reales del examinador, los planes semana a semana y los simulacros que muy probablemente no tenés sistematizados todavía. Y el Módulo 6 te muestra cómo cobrar por programa en lugar de por hora.'
  }, {
    q: '¿Por qué elegir el Pack PRO y no el estándar?',
    a: 'El Tomo PRO I te enseña a entrar al mercado corporativo — empresas italianas que pagan en dólares sin regatear. Con una sola clase corporativa bien cotizada recuperás la diferencia de $10.000 entre las dos ofertas. El Tomo PRO II te da el sistema para crear ingresos digitales que funcionan mientras dormís.'
  }, {
    q: '¿Tiene garantía real?',
    a: '7 días de garantía total. Si abrís el Kit, lo probás con tus alumnos y no es lo que esperabas, te devolvemos el 100% sin preguntas ni formularios. La tasa de devoluciones es menor al 1%.'
  }, {
    q: '¿El material está adaptado al contexto argentino?',
    a: 'Completamente. Todo el Kit usa vocabulario rioplatense, casos reales de Buenos Aires, Rosario, Córdoba y Mendoza, referencias a los consulados italianos reales de Argentina y precios en pesos y dólares actualizados para el mercado 2024/2025.'
  }, {
    q: '¿Qué diferencia tiene con los libros de italiano importados?',
    a: 'Los libros importados están en italiano, son caros y no tienen contexto argentino. El KIT ITALIANO PRO™ está completamente en español rioplatense, adaptado al alumno argentino, con herramientas listas para usar mañana mismo — no en 6 meses cuando termines de leerlo.'
  }];
  return <section className="py-20 px-5 bg-bg-alt" data-id="element-92">
      <div className="max-w-[720px] mx-auto" data-id="element-93">
        <div className="text-center mb-10" data-id="element-94">
          <p className="text-xs tracking-[0.1em] uppercase text-cyan mb-3 font-semibold" data-id="element-95">
            Dudas comunes
          </p>
          <h2 className="text-[clamp(26px,4vw,36px)] font-extrabold leading-[1.2]" data-id="element-96">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="flex flex-col gap-1.5" data-id="element-97">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="border border-gris-medio rounded-lg overflow-hidden bg-gris-oscuro" data-id="element-98">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full text-left px-5 py-4 flex justify-between items-center gap-3 hover:bg-[#222] transition-colors" aria-expanded={isOpen} data-id="element-99">
                  <span className="text-[15px] font-semibold text-blanco pr-4" data-id="element-100">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 45 : 0
              }} transition={{
                duration: 0.2
              }} className="text-cyan shrink-0" data-id="element-101">
                    <PlusIcon size={20} data-id="element-102" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-103">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="bg-[#111]" data-id="element-104">
                      <div className="px-5 pb-5 pt-1 text-[14px] text-[#aaa] leading-relaxed" data-id="element-105">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
};